module.exports = {
  google: {
    API_KEY: "",
    CLIENT_ID: "",
    SECRET: "",
  },
  facebook: {
    APP_ID: "",
  },
  api: {


    // API_URL: "http://127.0.0.1:8000/api",
    // IMAGE_URL: "http://127.0.0.1:8000/storage/uploads/",
    // SAMPLE_URL: "http://127.0.0.1:8000/sample/",


    // API_URL: "http://10.15.2.25:8000/theroy-apis/public/api",
    // IMAGE_URL: "http://10.15.2.25:8000/theroy-apis/public/storage/uploads/",
    // SAMPLE_URL: "http://10.15.2.25:8000/theroy-apis/public/sample/",

    API_URL: "https://theroy.designkorner.com/internal-theory-apis/api",
    IMAGE_URL: "https://theroy.designkorner.com/internal-theory-apis/public/storage/uploads/",
    SAMPLE_URL: "https://theroy.designkorner.com/internal-theory-apis/public/sample/",

    FLAGS: "../../assets/images/flags/",
  },
};